module.exports = __webpack_public_path__ + "img/runnerbondhorizontal.52063ec2.png";